import axios from "axios";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import styles from "./client.module.scss";

export default function ClientComponent({
  client,
  setClient,
  setClientObj,
  changeAddress,
  address,
  type,
  delivery,
}) {
  const api = process.env.REACT_APP_API;
  const [clients, setClients] = useState([]);
  const [contactAddress, setContactAddress] = useState([]);

  useEffect(() => {
    axios
      .get(`${api}contact/all`, {
        params: {
          business: process.env.REACT_APP_BUSINESS,
        },
      })
      .then(({ data }) => {
        setClients(
          data.map((obj) => {
            return {
              label: `${obj.name}${obj.phone ? " - " + obj.phone : ""}`,
              value: obj._id,
            };
          })
        );
      });
  }, []);

  const changeClient = (e) => {
    if (e) {
      setClient(e);
      setClientObj(clients.find((list) => list.value == e.value));
      axios
        .get(`${api}contact/address/all`, {
          params: {
            client: e.value,
            business: process.env.REACT_APP_BUSINESS,
          },
        })
        .then((data) => {
          setContactAddress(data.data);
        });
    } else {
      setClient(undefined);
      setClientObj(undefined);
      setContactAddress([]);
    }
  };

  return type !== "edit" && type !== "view" ? (
    <div>
      <Select
        instanceId="producto"
        isMulti={false}
        isClearable={true}
        value={client}
        onChange={(e) => changeClient(e)}
        placeholder="Cliente"
        options={clients}
        // styles={config.select}
        // components={{
        //   DropdownIndicator: DropdownIndicator,
        //   ClearIndicator: ClearIndicator,
        // }}
      />
      <br />
      {client && (
        <Select
          isMulti={false}
          isClearable={true}
          onChange={(e) => changeAddress(e)}
          getOptionLabel={(option) => {
            return (
              <div>
                <div className={styles.addressName}>{option.name}</div>
                <div className={styles.addressSmall}>{option.address}</div>
              </div>
            );
          }}
          getOptionValue={(option) => option._id}
          placeholder="Dirección"
          options={contactAddress}
          filterOption={(option, searchText) => {
            if (
              option.data.name
                .toLowerCase()
                .includes(searchText.toLowerCase()) ||
              option.data?.address
                .toLowerCase()
                .includes(searchText.toLowerCase())
            ) {
              return true;
            } else {
              return false;
            }
          }}
          styles={{
            singleValue: (provided, state) => {
              return {
                padding: "5px 0px",
              };
            },
            valueContainer: (provided, state) => {
              return {
                ...provided,
                display: "flex",
              };
            },
            option: (provided, state) => {
              let backgroundColor = "#FFF";

              if (state.isFocused || state.isSelected) {
                backgroundColor = "#ededed";
              }

              return {
                ...provided,
                backgroundColor: backgroundColor,
              };
            },
            control: () => {
              return {
                display: "flex",
                minHeight: 38,
                justifyContent: "space-between",
                border: " 1px solid #dde2ec",
                borderRadius: 6,
              };
            },
          }}
          value={address && contactAddress.find((list) => list._id === address)}
        />
      )}
    </div>
  ) : client ? (
    <>
      <div className={styles.name}>{client.label}</div>
      {delivery && (
        <div className={styles.addressSmall}>{delivery?.steps[0]?.address}</div>
      )}
      <br />
    </>
  ) : (
    ""
  );
}
